/** Old `str_`: null → '', trimmed, the literal "NULL" counts as empty. */
export function str(v: unknown): string {
  if (v == null) return '';
  const s = String(v).trim();
  return s === 'NULL' ? '' : s;
}

/** Case- and space-insensitive key for person names and emails. */
export function lowerKey(v: unknown): string {
  return str(v).toLowerCase();
}

/** Case- and diacritic-insensitive key for a person's name (old agendaKey_, AgendaSync.gs:740). */
export function nameKey(v: unknown): string {
  return str(v)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** "1 comment", "3 comments": the count and the word, plural when it is not 1. */
export const plural = (n: number, word: string): string => `${n} ${word}${n === 1 ? '' : 's'}`;

/** A programme's DisplayOrder; blank or not a number = 99, i.e. last (old `Number(x || 99)`). */
export function orderOf(v: unknown): number {
  const n = typeof v === 'number' ? v : Number(str(v) || NaN);
  return Number.isFinite(n) ? n : 99;
}
